export default __webpack_public_path__ + "static/media/question_well_config_A.42e2426e.jpg";